import { DateTime } from "luxon";

export default {
  install: (app, options) => {
    const getNextDay = (date) => {
      const nextDay = new Date(date);
      nextDay.setDate(nextDay.getDate() + 1);
      nextDay.setHours(0, 0, 0, 0);

      return nextDay;
    };
    const getNextMonday = (date = new Date()) => {
      const dateCopy = new Date(date.getTime());

      return new Date(
        dateCopy.setDate(
          dateCopy.getDate() + ((7 - dateCopy.getDay() + 1) % 7 || 7)
        )
      );
    };
    const getMonday = (date = new Date()) => {
      let day = date.getDay(),
        diff = date.getDate() - day + (day === 0 ? -6 : 1);

      return new Date(date.setDate(diff));
    };
    const getSunday = (date = new Date()) => {
      // If day is sunday return same day
      if (date.getDay() === 0) {
        const sunday = new Date(date);
        sunday.setHours(23, 59, 59, 999);

        return date;
      }

      const currentDayIndex = date.getDay();
      const difference = 7 - currentDayIndex;

      const sunday = new Date(date);
      sunday.setDate(date.getDate() + difference);
      sunday.setHours(23, 59, 59, 999);

      return sunday;
    };
    const calculateNextMissingInterval = (
      isWeekly,
      lastProgressDate,
      userStartAtDate
    ) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (!lastProgressDate && today > userStartAtDate) {
        return userStartAtDate;
      } else if (!lastProgressDate && today <= userStartAtDate) {
        return null;
      }

      let nextIntervalFrom = null;
      let nextIntervalUntil = null;

      if (isWeekly) {
        // Interval from monday til sunday
        nextIntervalFrom = getNextMonday(lastProgressDate);
        nextIntervalUntil = getSunday(nextIntervalFrom);
      } else {
        nextIntervalFrom = getNextDay(lastProgressDate);
        nextIntervalUntil = new Date(nextIntervalFrom);
        nextIntervalUntil.setHours(23, 59, 59, 999);
      }

      if (today > nextIntervalUntil) {
        return nextIntervalFrom;
      }

      return null;
    };

    // Formats date to dd.mm.YYYY, HH:mm Uhr
    const formatDateGermanFormatWithTime = (date) => {
      const luxonDateTime = DateTime.fromISO(date);

      return luxonDateTime.toFormat("dd.MM.yyyy, HH:mm");
    };

    // Formats date to dd.mm.YYYY without considering timezones
    const formatDateGermanFormat = (date) => {
      const day = addTrailingZero(date.getDate(), 2);
      const month = addTrailingZero(date.getMonth() + 1, 2);
      const year = date.getFullYear();

      return day + "." + month + "." + year;
    };

    // Formats date to yyyy-mm-dd HH:ii:ss without considering timezones
    const formatDate = (date) => {
      const day = addTrailingZero(date.getDate(), 2);
      const month = addTrailingZero(date.getMonth() + 1, 2);
      const year = date.getFullYear();
      const hours = addTrailingZero(date.getHours(), 2);
      const minutes = addTrailingZero(date.getMinutes(), 2);
      const seconds = addTrailingZero(date.getSeconds(), 2);

      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    };

    // Formats date to yyyy-mm-dd without considering timezones
    const formatDateWithoutTime = (date) => {
      const day = addTrailingZero(date.getDate(), 2);
      const month = addTrailingZero(date.getMonth() + 1, 2);
      const year = date.getFullYear();

      return year + "-" + month + "-" + day;
    };

    const addTrailingZero = (value, length) => {
      let valueAsString = value.toString();
      if (valueAsString.length < length) {
        valueAsString = "0" + valueAsString;
      }

      return valueAsString;
    };

    app.config.globalProperties.$dateManager = {
      getNextDay,
      getNextMonday,
      getSunday,
      getMonday,
      calculateNextMissingInterval,
      formatDate,
      formatDateGermanFormat,
      formatDateWithoutTime,
      formatDateGermanFormatWithTime,
    };
  },
};
